import { ImgHTMLAttributes, useMemo } from 'react';

import { ImageFormat } from '../enums';
import { FileFragment } from '../graphql/generated/graphql';
import { generateImageSrcSet, getStrapiImageUrl } from '../utils';

interface Props extends ImgHTMLAttributes<HTMLImageElement> {
  file?: FileFragment | null;
  fallbackFormat?: ImageFormat;
  fileUrl?: string | null;
  sizes: string;
  alt: string;
  className?: string;
}

export const Image = ({
  file,
  fileUrl,
  sizes,
  fallbackFormat,
  alt,
  className,
  ...imageProps
}: Props) => {
  const src = useMemo(() => {
    if (fileUrl) return fileUrl;
    if (file) return getStrapiImageUrl(file, fallbackFormat);
  }, [file, fileUrl, fallbackFormat]);

  const srcSet = useMemo(() => {
    if (file) return generateImageSrcSet(file);
    return undefined;
  }, [file]);

  return (
    <img
      src={src}
      srcSet={srcSet}
      sizes={sizes}
      alt={alt}
      className={className}
      {...imageProps}
    />
  );
};
